import { ccLocaleMap, VIDEO_EMBED_IDS } from '#src/app/pages/about/impact/shared/consts';
import { useLocale } from '#src/app/shared/hooks/l10n';

type Result = ModelHookResult<{
	embedHtml: string;
}>;

export function useGetEmbedUrl(): Result {
	const locale = useLocale();
	const ccLocale = ccLocaleMap[locale] || 'en';
	const embedId = VIDEO_EMBED_IDS[locale] || VIDEO_EMBED_IDS.default;
	const embedUrl = `https://www.youtube-nocookie.com/embed/${embedId}?cc_load_policy=1&cc_lang_pref=${ccLocale}&hl=${ccLocale}&enablejsapi=1`;

	const embedHtml = `<iframe width="560" height="315" src="${embedUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
	return {
		data: { embedHtml },
	};
}
